import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { DocsComponentName } from "../constant";
import { getExtensionSafe } from "../utils";
import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
export var SHARE_LINK_PATH = '/components/docs/SharePrivateMobile.html';
export var openSharePanel = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(option) {
    var padId, _option$isMobile, isMobile, _option$shareLink, shareLink, _option$shareTitle, shareTitle, _option$shareDocType, shareDocType, appOption, sharePanelURL, extension;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          padId = option.padId, _option$isMobile = option.isMobile, isMobile = _option$isMobile === void 0 ? false : _option$isMobile, _option$shareLink = option.shareLink, shareLink = _option$shareLink === void 0 ? '' : _option$shareLink, _option$shareTitle = option.shareTitle, shareTitle = _option$shareTitle === void 0 ? '' : _option$shareTitle, _option$shareDocType = option.shareDocType, shareDocType = _option$shareDocType === void 0 ? '' : _option$shareDocType, appOption = option.appOption;
          if (!isMobile) {
            _context.next = 7;
            break;
          }
          sharePanelURL = "".concat(location.origin).concat(SHARE_LINK_PATH, "?localPadId=").concat(padId);
          if (!(location.pathname === SHARE_LINK_PATH)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          tencentDocOpenUrlForAll({
            url: sharePanelURL,
            appOption: appOption
          });
          return _context.abrupt("return");
        case 7:
          _context.next = 9;
          return getExtensionSafe(DocsComponentName.SHARE_PRIVATE);
        case 9:
          extension = _context.sent;
          extension.show({
            padId: padId,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareDocType: shareDocType
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function openSharePanel(_x) {
    return _ref.apply(this, arguments);
  };
}();